export default "__VITE_ASSET__xSmvlUYd__"